import { render } from "./narvar2.vue?vue&type=template&id=d9225ed6&scoped=true"
import script from "./narvar2.vue?vue&type=script&lang=js"
export * from "./narvar2.vue?vue&type=script&lang=js"

import "./narvar2.vue?vue&type=style&index=0&id=d9225ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9225ed6"]])

export default __exports__